const plumberDetailedRateCard = {
  key: "plumber",
  title: "Plumber Detailed Rate Card",
  note:
    "Indicative plumbing pricing. Final price depends on parts used, leakage severity, accessibility, wall opening, material brand, and live backend pricing rules. Transparent pricing is preferred over inflated hidden markups.",
  sections: [
    {
      title: "Tap & Mixer",
      items: [
        { name: "Tap repair", price: "₹149 per tap" },
        { name: "Tap installation", price: "₹199 per tap" },
        { name: "Tap replacement", price: "₹249 per tap" },
        { name: "Mixer installation", price: "₹249 per unit" },
        { name: "Angle valve replacement", price: "₹149 per valve" },
      ],
    },
    {
      title: "Bathroom & Shower",
      items: [
        { name: "Shower installation", price: "₹249 per unit" },
        { name: "Health faucet installation", price: "₹149 per unit" },
        { name: "Flush tank repair", price: "₹249 per unit" },
        { name: "Flush tank replacement", price: "₹399 per unit" },
        { name: "Western commode fitting support", price: "₹799 onwards" },
      ],
    },
    {
      title: "Leakage & Drainage",
      items: [
        { name: "Minor leakage fix", price: "₹179 onwards" },
        { name: "Drain blockage clearing", price: "₹249 onwards" },
        { name: "Basin pipe leak repair", price: "₹179 per point" },
        { name: "Drain pipe replacement", price: "₹120 per meter + labour" },
        { name: "Hidden leakage inspection", price: "₹299 visit" },
      ],
    },
    {
      title: "Motor & Supply",
      items: [
        { name: "Water motor check", price: "₹199 visit" },
        { name: "Pipeline inspection", price: "₹249 visit" },
        { name: "Water tank connection check", price: "₹249 visit" },
      ],
    },
  ],
};

export default plumberDetailedRateCard;